import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {AbstractRepositoryV2} from '../../../../../../core/service/v2/abstractRepositoryV2';
import {AgendaEventModel} from '../../../api/entity/agendaEvent.model';

@Injectable({
    providedIn: 'root'
})
export class AgendaEventRepository extends AbstractRepositoryV2<AgendaEventModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('AgendaEvent', serviceElementsFactory, injector);
    }
}
